import { defineStore } from 'pinia';

//storage存取
const localGet = (k) => {
    const data = localStorage.getItem(k);
    return data ? JSON.parse(data) : null;
}
const localSet = (k, v) => {
    localStorage.setItem(k, JSON.stringify(v));
}

export const useMainStore = defineStore('main', {
	state: () => {
		return {
			globalConfig: localGet("global_config") || 1,
            userInfo: localGet("user_info"),
            menuList: localGet("menu_list"),
		}
	},
	actions: {
        /** 设置全局配置 */
         setGlobalConfig(globalConfig) {
			this.globalConfig = globalConfig;
			localSet("global_config", globalConfig);
		},
        /** 设置用户信息 */
        setUserInfo(userInfo) {
            this.userInfo = userInfo;
            localSet("user_info", userInfo);
        },
        /** 设置用户菜单 */
        setMenu(gmList) {
            this.menuList = gmList;
            localSet("menu_list", gmList);
        },
        /** 退出-清理全部 */
        clear() {
            localStorage.clear();
        }
	}
})